import { observer } from 'mobx-react';
import React from 'react';
import { PromiseMessage } from '../../../lib/components';
import { promiseStates, ReactNodeGenerator } from '../../../lib/helpers';
import { ExamStudentSceneStore } from '../student/ExamStudentSceneStore';
import { StudentExamTabs } from '../student/StudentExamTabs'

const ps = promiseStates;

function* renderer(store: ExamStudentSceneStore): ReactNodeGenerator {

  const { snapshotState } = store;
  yield (
    <PromiseMessage key="lesson-loader-state"
      label="Loading lesson"
      state={snapshotState}
      align="right" />);

  if (ps.isRejected(snapshotState)) {
    yield (
      <div className="row" key="lesson-load-action">
        <div className="col-auto ml-auto">
          <button type="button" className="btn btn-primary"
            onClick={store.loadLessonExam}>
            Load lesson
          </button>
        </div>
      </div>
    );
  }

  
  yield (<StudentExamTabs store={store} key="homework-lesson-tabs" />);
}

interface Props {
  id: number;
}

@observer
export class ExamTeacherScene extends React.Component<Props> {
  readonly store: ExamStudentSceneStore;

  constructor(props: Readonly<Props>) {
    super(props);

    this.store = new ExamStudentSceneStore(props.id);
  }

  componentDidMount() {
    this.store.loadExam();
  }

  render() {
    return Array.from(renderer(this.store));
  }

  componentWillUnmount() {
    this.store.dispose();
  }
}
